import script from "./ItensProcessoForm_14.vue?vue&type=script&setup=true&lang=js"
export * from "./ItensProcessoForm_14.vue?vue&type=script&setup=true&lang=js"

import "./ItensProcessoForm_14.vue?vue&type=style&index=0&id=3aa96759&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa96759"]])

export default __exports__